import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons";

export function ErrorBoundaryFallback() {
    return (
        <>
            <h1 className="page-header">
                <FontAwesomeIcon
                    icon={faCircleExclamation}
                    className="text-primary me-1"
                />{" "}
                Ett fel uppstod
            </h1>
            <div>
                Våra tekniker har blivit informerade om problemet och kommer att
                felsöka och åtgärda det så fort som möjligt.
            </div>
        </>
    );
}
